module.exports = new __parcel__URL__("mercenary_wolvez_hideout_level_4.687c358a.png").toString();